(() => {
  const mobile = window.matchMedia('(max-width: 767px)');
  const root = document.documentElement;
  let host, runtime, shadow, launcher, button, frame;
  let attempts = 0;
  let protectedElements = [];
  const collect = () => {
    protectedElements = Array.from(document.querySelectorAll('.ms-product-gallery, .ms-product-form, a[href*="/products/"] img, button, input, select, summary'));
  };
  const update = () => {
    frame = null;
    if (!launcher || !button) return;
    if (!mobile.matches || button.getAttribute('aria-expanded') === 'true') {
      launcher.removeAttribute('data-ms-obstructed');
      return;
    }
    const rect = button.getBoundingClientRect();
    const obstructed = protectedElements.some(element => {
      const box = element.getBoundingClientRect();
      return box.width && box.height && box.left < rect.right + 8 && box.right > rect.left - 8 && box.top < rect.bottom + 8 && box.bottom > rect.top - 8;
    });
    launcher.toggleAttribute('data-ms-obstructed', obstructed);
  };
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };
  const attach = () => {
    host = document.querySelector('shopify-chat');
    runtime = host?.shadowRoot?.querySelector('shopify-agent-runtime');
    shadow = runtime?.shadowRoot;
    launcher = shadow?.querySelector('.activator-nudge');
    button = shadow?.querySelector('[part="activator"]');
    if (!launcher || !button) {
      if (++attempts < 150) setTimeout(attach, 200);
      return;
    }
    const style = document.createElement('style');
    style.textContent = `
      @media (max-width: 767px) {
        .activator-nudge {
          bottom: calc(12px + env(safe-area-inset-bottom, 0px)) !important;
          right: 12px !important;
          left: auto !important;
        }
        .activator {
          width: 44px !important;
          height: 44px !important;
          min-width: 44px !important;
          min-height: 44px !important;
          padding: 0 !important;
          display: grid !important;
          grid-template-columns: 1fr !important;
          place-items: center !important;
          gap: 0 !important;
          border-radius: 50% !important;
          background: #f8f8f8 !important;
          color: #202322 !important;
          border: 1px solid #d9dbd7 !important;
          box-shadow: 0 2px 8px rgb(32 35 34 / 8%) !important;
        }
        .activator__label { display: none !important; }
        .activator__icon { width: 20px !important; height: 20px !important; color: #202322 !important; }
        .activator__icon shopify-chat-icon { color: #202322 !important; }
        .activator-nudge[data-ms-obstructed] { visibility: hidden !important; pointer-events: none !important; }
        .activator:focus-visible { outline: 2px solid #202322 !important; outline-offset: 3px !important; }
      }
    `;
    shadow.appendChild(style);
    collect();
    new MutationObserver(schedule).observe(button, {attributes: true, attributeFilter: ['aria-expanded']});
    new MutationObserver(schedule).observe(root, {attributes: true, attributeFilter: ['class']});
    window.addEventListener('scroll', schedule, {passive: true, capture: true});
    window.addEventListener('resize', schedule, {passive: true});
    window.visualViewport?.addEventListener('resize', schedule);
    mobile.addEventListener('change', schedule);
    document.addEventListener('load', schedule, true);
    document.addEventListener('shopify:section:load', () => { collect(); schedule(); });
    document.addEventListener('click', schedule);
    if (window.ResizeObserver) new ResizeObserver(schedule).observe(document.body);
    schedule();
  };
  attach();
})();
